export default {
    id: 'offset',
    afterUpdate: function(chart) {
        // We get the dataset and set the offset here
        // var dataset = chart.config.data.datasets[0];
        var offset = 40
        // debugger;
        for (const dataset of chart.config.data.datasets) {
            for (var i = 0; i < dataset.data.length; i++) {
                for (var key in dataset._meta)
                {
                    var model = dataset._meta[key].data[i]._model
                    // ctx.fillText(dataset.data[i], model.x, model.y - 5);
                }
            }
        }

        // const metas = chart.getSortedVisibleDatasetMetas();

        // for(let meta of metas) {
        //     // debugger;
        //     for(let dataPoint of meta.data) {
        //         let model = dataPoint._model;
        //         console.log(model);

        //         model.x += offset;
        //         // model.
        //     }
        // }
        // debugger;

        // for(let dataset of chart.config.data.datasets) {
        //     debugger;
        //     for (var i = 0; i < dataset._meta[0].data.length; i++) {
        //         // We get the model linked to this data
        //         var model = dataset._meta[0].data[i]._model;

        //         // And add the offset to the `x` property
        //         model.x += offset;

        //         // .. and also to these two properties
        //         // to make the bezier curve fits the new graph
        //         model.controlPointNextX += offset;
        //         model.controlPointPreviousX += offset;
        //     }
        // }
    }
}
